import LazyImage from 'components/images/LazyImage';
import clsx from 'clsx';

interface Props {
  alt?: string;
  backgroundColor?: string;
  imageUrl?: string;
  className?: string;
  imageClassName?: string;
  onClick?(): void;
}

const CircleImage = ({
  alt,
  backgroundColor,
  imageUrl,
  className,
  onClick,
  imageClassName,
}: Props) => {
  const imageContainerClassName = clsx('Profile-imageContainer', className, {
    'is-clickable': !!onClick,
  });
  return (
    <div className={imageContainerClassName}>
      {imageUrl ? (
        <LazyImage
          className={clsx('Profile-imageObject', imageClassName)}
          alt={alt}
          src={imageUrl}
          backgroundColor={backgroundColor}
          fade={{ enterTimeout: 500, exitTimeout: 500 }}
          backgroundImage={true}
        />
      ) : (
        <div className="Profile-imageObject CircleImage-placeholder"></div>
      )}
    </div>
  );
};

export default CircleImage;
